import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { submitSurveyAnswers } from '../api/surveys.api';
import type { SubmittedSurveyRef, SubmitSurveyPayload } from '../types/survey.types';

export function useSubmitSurveyAnswers(
  surveyId: number,
  onSuccess?: (submission: SubmittedSurveyRef) => void,
) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: SubmitSurveyPayload) => submitSurveyAnswers(surveyId, payload),
    onSuccess: (submission) => {
      void refreshRelatedData('survey');
      toast.success('Response submitted successfully');
      onSuccess?.(submission);
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to submit response');
    },
  });
}
